import { find, includes, not, pathOr, propEq } from 'ramda';
import { isNotEmpty } from 'src/utilities/hasValue';

export const check = (
  rules: any,
  action: any,
  data?: any,
  matchParams?: any,
  notMatchParams?:any
) => {
  const permissions = rules;
  if (!permissions) {
    // role is not present in the rules
    return false;
  }
  const isPermissionMatch = find(propEq('name', action), permissions);

  const othersOptions = pathOr({}, ['options'], isPermissionMatch);
  const matchKey = pathOr('', ['key'], matchParams);
  const matchValue = pathOr('', ['value'], matchParams)
  const matchOptions = pathOr([], [matchKey], othersOptions)

  const notMatchKey = pathOr('', ['key'], notMatchParams);
  const notMatchValue = pathOr('', ['value'], notMatchParams)
  const notMatchOptions = pathOr([], [notMatchKey], othersOptions)

  if ((isNotEmpty(matchOptions) || isNotEmpty(notMatchOptions))) {
    const isOptionMatched = isNotEmpty(find(propEq('value', matchValue), matchOptions));
    const isOptionNotMatched = isNotEmpty(notMatchParams) && not(includes(notMatchValue,notMatchOptions))
    return isOptionMatched || isOptionNotMatched
  }

  return isNotEmpty(isPermissionMatch)
};

interface Props {
  rules: any;
  perform: any;
  yes: any;
  no: any;
  data?: any;
  matchParams?: any;
  notMatchParams?:any
}

const Can = (props: Props) =>
  check(
    props.rules,
    props.perform,
    props.data,
    pathOr('', ['matchParams'], props),
    pathOr('', ['notMatchParams'], props)
  )
    ? props.yes()
    : props.no();

Can.defaultProps = {
  yes: () => null,
  no: () => null,
};

export default Can;

/** canGuard is a HOF function to be used where the 
  HOC Can component cant be used.
**/

export const canGuard = (rules: any, perform: any) => {
  return check(rules, perform, '');
};
